<template>

    <div class="layout__container layout__padding-20-0">

        <div class="layout__padding-clear layout__width-50">
        <div class="text__align-center text__colour-white">
            <div class="layout__padding-clear layout__padding-20-0">
                <h2><i class="icon-alert text__colour-red text__align-center layout__padding-0-20"></i></h2>


                <h2 v-if="errorType === 'onhold'" class="text__colour-red">Account on hold</h2>

                <h2 v-else class="text__colour-red">Error</h2>
            </div>
        </div>

        <div>

                <div v-show="errorType === 'noproducts'">
                    <NoProducts v-bind:printJob="printJob"></NoProducts>
                </div>

                <div v-show="errorType === 'onhold'">
                    <OnHold></OnHold>
                </div>

                <div v-show="errorType === 'incomplete'">
                    <IncompleteEntry></IncompleteEntry>
                </div>

                <div v-show="errorType === 'noresults'">
                    <NoResultsFound v-bind:printJob="printJob" v-bind:issue="issue"></NoResultsFound>
                </div>

                <div v-show="errorType === 'nopdf'">
                    <NoArtwork></NoArtwork>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
    import NoProducts from '@/components/tools/pdfupload/NoProducts.vue';
    import IncompleteEntry from '@/components/tools/pdfupload/IncompleteEntry.vue';
    import NoArtwork from '@/components/tools/pdfupload/NoArtwork.vue';
    import OnHold from '@/components/tools/pdfupload/OnHold.vue';
    import NoResultsFound from '@/components/tools/pdfupload/NoResultsFound.vue';
    import StepGuide from '@/components/tools/pdfupload/StepGuide.vue';

    export default {
        name: "start",
        components: {
            NoProducts,
            IncompleteEntry,
            OnHold,
            NoResultsFound,
            StepGuide,
            NoArtwork
        },
        props: {
            errorType: String,
            printJob: Object,
            searchParams: Object,
            issue: ''
        },
        data() {
            return {}
        },
        created() {
            console.log(this.issue)
            console.log(this.errorType)
        },
        methods: {}
    };
</script>